"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var React = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("../../../../Layout/Box"));

var _VisualCheckbox = require("./VisualCheckbox");

var _TrueCheckbox = require("./TrueCheckbox");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

// TODO: Margin, padding bg, color being applied to wrong element (input instead of checkbox icon)
var Checkbox = React.forwardRef(function (_a, ref) {
  var sx = _a.sx,
      _b = _a.variant,
      variant = _b === void 0 ? 'forms.checkbox' : _b,
      props = (0, _tslib.__rest)(_a, ["sx", "variant"]);
  return React.createElement(_Box.default, {
    sx: {
      position: 'relative',
      '::focus-within': {
        outline: '1px dotted black'
      }
    }
  }, React.createElement(_TrueCheckbox.TrueCheckbox, (0, _tslib.__assign)({
    ref: ref
  }, props)), React.createElement(_VisualCheckbox.VisualCheckbox, {
    variant: variant,
    sx: sx
  }));
});
var CheckboxInput = React.forwardRef(function (_a, ref) {
  var id = _a.id,
      props = (0, _tslib.__rest)(_a, ["id"]);
  return React.createElement(Checkbox, (0, _tslib.__assign)({
    ref: ref,
    id: id
  }, props));
});
CheckboxInput.displayName = 'CheckboxInput';
var _default = CheckboxInput;
exports.default = _default;